import { viaTextFormatString } from './SenderPersonaWrapper.locstring.json';
import { onBehalfOfTextFormatString } from 'owa-locstrings/lib/strings/onbehalfoftextformatstring.locstring.json';
import loc, { formatToArray } from 'owa-localize';
import SenderPersona from './SenderPersona';
import getIsSentOnBehalfOf from '../utils/getIsSentOnBehalfOf';
import { observer } from 'mobx-react-lite';
import Message from 'owa-service/lib/contract/Message';
import MessageSafetyLevel from 'owa-service/lib/contract/MessageSafetyLevel';

import * as React from 'react';

const styles = require('./SenderPersona.scss');
const classNames = require('classnames');

export interface SenderPersonaWrapperProps {
    message: Message;
    treatAsDraft: boolean;
    isNodePending: boolean;
    hideSMTP?: boolean;
    senderPersonaClassName?: string;
    showPlainText?: boolean;
    displaySelf?: boolean;
    displayYouForSelf?: boolean;
    useIsReadStyle?: boolean;
    className?: string;
}

const SenderPersonaWrapper = observer(function SenderPersonaWrapper(
    props: SenderPersonaWrapperProps
) {
    const {
        message,
        treatAsDraft,
        isNodePending,
        hideSMTP,
        senderPersonaClassName,
        displaySelf,
        displayYouForSelf,
        useIsReadStyle,
        className,
    } = props;
    const isSentOnBehalfOf = getIsSentOnBehalfOf(message);
    const messageSafetyLevel = message.MessageSafety
        ? message.MessageSafety.MessageSafetyLevel
        : MessageSafetyLevel.None;
    const treatAsRead = useIsReadStyle || message.IsRead;
    let personaToDisplay: JSX.Element | (string | JSX.Element)[];

    const fromPersona = (
        <SenderPersona
            sender={message.From ? message.From : message.Sender}
            isRead={treatAsRead}
            treatAsDraft={treatAsDraft}
            displaySelf={displaySelf || isNodePending}
            hideSMTP={hideSMTP}
            messageSafetyLevel={messageSafetyLevel}
            isUnauthenticatedSender={message.AntispamUnauthenticatedSender}
            className={senderPersonaClassName}
            showPlainText={props.showPlainText}
            displayYouForSelf={displayYouForSelf && !isSentOnBehalfOf && !message.ViaInFrom}
        />
    );

    if (isSentOnBehalfOf) {
        personaToDisplay = formatToArray(
            loc(onBehalfOfTextFormatString),
            <SenderPersona
                sender={message.Sender}
                isRead={treatAsRead}
                treatAsDraft={treatAsDraft}
                displaySelf={false}
                hideSMTP={hideSMTP}
                messageSafetyLevel={messageSafetyLevel}
                isUnauthenticatedSender={message.AntispamUnauthenticatedSender}
                className={senderPersonaClassName}
                showPlainText={props.showPlainText}
            />,
            fromPersona
        );
    } else if (message.ViaInFrom) {
        personaToDisplay = formatToArray(
            loc(viaTextFormatString),
            fromPersona,
            <span>{message.ViaInFrom}</span>
        );
    } else {
        personaToDisplay = fromPersona;
    }

    return (
        <span
            className={classNames(
                styles.senderLineText,
                !treatAsRead && styles.isUnread,
                className
            )}>
            {personaToDisplay}
        </span>
    );
});
export default SenderPersonaWrapper;
